// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BanketteCatering Component Styles */
.bankette-catering {
  min-height: 100vh;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);
}

.bankette-catering__container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* Hero Section */
.bankette-catering__hero {
  position: relative;
  height: 60vh;
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.bankette-catering__hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
}

.bankette-catering__hero-bg::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 2;
}

.bankette-catering__hero-content {
  position: relative;
  z-index: 3;
  text-align: center;
  color: white;
  width: 100%;
}

.bankette-catering__hero-title {
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  letter-spacing: 2px;
}

.bankette-catering__hero-subtitle {
  font-size: 1.8rem;
  font-weight: 400;
  margin: 2rem 0;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.bankette-catering__hero-description {
  font-size: 1.2rem;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.bankette-catering__emoji {
  margin-right: 1rem;
  font-size: 1.5em;
}

/* Divider */
.bankette-catering__divider {
  font-size: 2rem;
  color: #4A90E2;
  text-align: center;
  margin: 3rem 0 2rem;
  letter-spacing: 1rem;
}

/* Sections */
.bankette-catering__section {
  padding: 4rem 0;
  border-bottom: 1px solid rgba(74, 144, 226, 0.1);
}

.bankette-catering__section:last-child {
  border-bottom: none;
}

.bankette-catering__section-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  min-height: 400px;
}

.bankette-catering__section--reverse .bankette-catering__section-content {
  direction: rtl;
}

.bankette-catering__section--reverse .bankette-catering__text-content,
.bankette-catering__section--reverse .bankette-catering__image-content {
  direction: ltr;
}

.bankette-catering__text-content {
  padding: 2rem;
}

.bankette-catering__section-title {
  font-size: 2.2rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.bankette-catering__section-icon {
  font-size: 2.5rem;
}

.bankette-catering__section-text {
  font-size: 1.1rem;
  line-height: 1.7;
}

.bankette-catering__text {
  margin-bottom: 1rem;
  color: inherit;
}

.bankette-catering__text:last-child {
  margin-bottom: 0;
}

/* Images */
.bankette-catering__image-content {
  height: 400px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(74, 144, 226, 0.2);
  transition: transform 0.3s ease;
}

.bankette-catering__image-content:hover {
  transform: translateY(-5px);
}

.bankette-catering__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.bankette-catering__image:hover {
  transform: scale(1.05);
}

.bankette-catering__image-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #f8f9ff 0%, #e9ecef 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #4A90E2;
  color: #4A90E2;
  cursor: pointer;
  transition: all 0.3s ease;
}

.bankette-catering__image-placeholder:hover {
  background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);
  border-color: #357ABD;
  color: #357ABD;
}

.bankette-catering__placeholder-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.bankette-catering__placeholder-text {
  font-size: 1.1rem;
  font-weight: 500;
  margin: 0;
}

/* Gallery */
.bankette-catering__gallery {
  padding: 4rem 0;
}

.bankette-catering__gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
}

.bankette-catering__gallery-item {
  height: 250px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(74, 144, 226, 0.15);
  transition: transform 0.3s ease;
}

.bankette-catering__gallery-item:hover {
  transform: translateY(-5px);
}

.bankette-catering__gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.bankette-catering__gallery-item:hover img {
  transform: scale(1.05);
}

/* Promise Section */
.bankette-catering__promise {
  padding: 4rem 0;
  text-align: center;
  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);
  border-radius: 20px;
  margin: 3rem 0;
  box-shadow: 0 15px 40px rgba(74, 144, 226, 0.1);
}

.bankette-catering__promise-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
}

.bankette-catering__promise-text {
  font-size: 1.2rem;
  line-height: 1.8;
  margin: 2rem 0;
  font-style: italic;
}

.bankette-catering__promise-image {
  width: 300px;
  height: 200px;
  margin: 2rem auto 0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(74, 144, 226, 0.2);
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .bankette-catering__container {
    padding: 0 1rem;
  }
  
  .bankette-catering__hero {
    height: 50vh;
    min-height: 400px;
  }
  
  .bankette-catering__hero-title {
    font-size: 2.5rem;
  }
  
  .bankette-catering__hero-subtitle {
    font-size: 1.4rem;
  }
  
  .bankette-catering__hero-description {
    font-size: 1rem;
  }
  
  .bankette-catering__section-content {
    grid-template-columns: 1fr;
    gap: 2rem;
    text-align: center;
  }
  
  .bankette-catering__section--reverse .bankette-catering__section-content {
    direction: ltr;
  }
  
  .bankette-catering__text-content {
    padding: 1rem;
  }
  
  .bankette-catering__section-title {
    font-size: 1.8rem;
    justify-content: center;
  }
  
  .bankette-catering__image-content {
    height: 300px;
  }
  
  .bankette-catering__gallery-grid {
    grid-template-columns: 1fr;
  }
  
  .bankette-catering__promise-content {
    padding: 1rem;
  }
  
  .bankette-catering__promise-image {
    width: 100%;
    max-width: 300px;
  }
}

@media (max-width: 480px) {
  .bankette-catering__hero-title {
    font-size: 2rem;
  }
  
  .bankette-catering__section-title {
    font-size: 1.5rem;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .bankette-catering__section-icon {
    font-size: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BanketteCatering.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;EAC/C,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;EAC/C,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA,0BAA0B;AAC1B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* BanketteCatering Component Styles */\n.bankette-catering {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);\n}\n\n.bankette-catering__container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n/* Hero Section */\n.bankette-catering__hero {\n  position: relative;\n  height: 60vh;\n  min-height: 500px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.bankette-catering__hero-bg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  z-index: 1;\n}\n\n.bankette-catering__hero-bg::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 2;\n}\n\n.bankette-catering__hero-content {\n  position: relative;\n  z-index: 3;\n  text-align: center;\n  color: white;\n  width: 100%;\n}\n\n.bankette-catering__hero-title {\n  font-size: 3.5rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\n  letter-spacing: 2px;\n}\n\n.bankette-catering__hero-subtitle {\n  font-size: 1.8rem;\n  font-weight: 400;\n  margin: 2rem 0;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n.bankette-catering__hero-description {\n  font-size: 1.2rem;\n  max-width: 800px;\n  margin: 0 auto;\n  line-height: 1.6;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n.bankette-catering__emoji {\n  margin-right: 1rem;\n  font-size: 1.5em;\n}\n\n/* Divider */\n.bankette-catering__divider {\n  font-size: 2rem;\n  color: #4A90E2;\n  text-align: center;\n  margin: 3rem 0 2rem;\n  letter-spacing: 1rem;\n}\n\n/* Sections */\n.bankette-catering__section {\n  padding: 4rem 0;\n  border-bottom: 1px solid rgba(74, 144, 226, 0.1);\n}\n\n.bankette-catering__section:last-child {\n  border-bottom: none;\n}\n\n.bankette-catering__section-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4rem;\n  align-items: center;\n  min-height: 400px;\n}\n\n.bankette-catering__section--reverse .bankette-catering__section-content {\n  direction: rtl;\n}\n\n.bankette-catering__section--reverse .bankette-catering__text-content,\n.bankette-catering__section--reverse .bankette-catering__image-content {\n  direction: ltr;\n}\n\n.bankette-catering__text-content {\n  padding: 2rem;\n}\n\n.bankette-catering__section-title {\n  font-size: 2.2rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.bankette-catering__section-icon {\n  font-size: 2.5rem;\n}\n\n.bankette-catering__section-text {\n  font-size: 1.1rem;\n  line-height: 1.7;\n}\n\n.bankette-catering__text {\n  margin-bottom: 1rem;\n  color: inherit;\n}\n\n.bankette-catering__text:last-child {\n  margin-bottom: 0;\n}\n\n/* Images */\n.bankette-catering__image-content {\n  height: 400px;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 10px 30px rgba(74, 144, 226, 0.2);\n  transition: transform 0.3s ease;\n}\n\n.bankette-catering__image-content:hover {\n  transform: translateY(-5px);\n}\n\n.bankette-catering__image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.bankette-catering__image:hover {\n  transform: scale(1.05);\n}\n\n.bankette-catering__image-placeholder {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, #f8f9ff 0%, #e9ecef 100%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border: 2px dashed #4A90E2;\n  color: #4A90E2;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.bankette-catering__image-placeholder:hover {\n  background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);\n  border-color: #357ABD;\n  color: #357ABD;\n}\n\n.bankette-catering__placeholder-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n}\n\n.bankette-catering__placeholder-text {\n  font-size: 1.1rem;\n  font-weight: 500;\n  margin: 0;\n}\n\n/* Gallery */\n.bankette-catering__gallery {\n  padding: 4rem 0;\n}\n\n.bankette-catering__gallery-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  margin-top: 2rem;\n}\n\n.bankette-catering__gallery-item {\n  height: 250px;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 8px 25px rgba(74, 144, 226, 0.15);\n  transition: transform 0.3s ease;\n}\n\n.bankette-catering__gallery-item:hover {\n  transform: translateY(-5px);\n}\n\n.bankette-catering__gallery-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.bankette-catering__gallery-item:hover img {\n  transform: scale(1.05);\n}\n\n/* Promise Section */\n.bankette-catering__promise {\n  padding: 4rem 0;\n  text-align: center;\n  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);\n  border-radius: 20px;\n  margin: 3rem 0;\n  box-shadow: 0 15px 40px rgba(74, 144, 226, 0.1);\n}\n\n.bankette-catering__promise-content {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.bankette-catering__promise-text {\n  font-size: 1.2rem;\n  line-height: 1.8;\n  margin: 2rem 0;\n  font-style: italic;\n}\n\n.bankette-catering__promise-image {\n  width: 300px;\n  height: 200px;\n  margin: 2rem auto 0;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 10px 25px rgba(74, 144, 226, 0.2);\n}\n\n/* Mobile Responsiveness */\n@media (max-width: 768px) {\n  .bankette-catering__container {\n    padding: 0 1rem;\n  }\n  \n  .bankette-catering__hero {\n    height: 50vh;\n    min-height: 400px;\n  }\n  \n  .bankette-catering__hero-title {\n    font-size: 2.5rem;\n  }\n  \n  .bankette-catering__hero-subtitle {\n    font-size: 1.4rem;\n  }\n  \n  .bankette-catering__hero-description {\n    font-size: 1rem;\n  }\n  \n  .bankette-catering__section-content {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n    text-align: center;\n  }\n  \n  .bankette-catering__section--reverse .bankette-catering__section-content {\n    direction: ltr;\n  }\n  \n  .bankette-catering__text-content {\n    padding: 1rem;\n  }\n  \n  .bankette-catering__section-title {\n    font-size: 1.8rem;\n    justify-content: center;\n  }\n  \n  .bankette-catering__image-content {\n    height: 300px;\n  }\n  \n  .bankette-catering__gallery-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .bankette-catering__promise-content {\n    padding: 1rem;\n  }\n  \n  .bankette-catering__promise-image {\n    width: 100%;\n    max-width: 300px;\n  }\n}\n\n@media (max-width: 480px) {\n  .bankette-catering__hero-title {\n    font-size: 2rem;\n  }\n  \n  .bankette-catering__section-title {\n    font-size: 1.5rem;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  .bankette-catering__section-icon {\n    font-size: 2rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
